import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  ModalLayout,
  InputFormTable,
  HtmlContent,
  Editor,
  UploadFile,
  Text,
} from 'components';
import {
  Button,
  DatePicker,
  Input,
  Radio,
  Switch,
  Flex,
  Select,
  Spin,
  Tag,
  Image,
  Table as AntTable,
} from 'antd';
import moment from 'moment';
import dayjs from 'dayjs';
import { DeleteOutlined } from '@ant-design/icons';
import { downloadXlsx } from 'utils/XlsxDownloader';
import { STORE_URL } from 'utils';

const INITIAL_VALUE = {
  start: '',
  end: '',
  keyword: 'event_title',
  search: '',
  show: '',
  main: '',
};

const SORT_ITEMS = [
  {
    label: '최신등록순',
    value: 'created_at-DESC',
  },
  {
    label: '오래된 등록순',
    value: 'created_at-ASC',
  },
  {
    label: '높은 노출 우선순위순',
    value: 'order-ASC',
  },
  {
    label: '낮은 노출 우선순위순',
    value: 'order-DESC',
  },
];

const EventListPresenter = (props) => {
  const {
    data,
    isOpened,
    modalData,
    // selectedItems,
    // setSelectedItems,
    file,
    isCheckedAll,
    checkedList,
    onChecked,
    onCheckedAll,
    modalType,
    onChange,
    onOpen,
    onSubmit,
    onDelete,
    onFileChange,
    isLoading,
    setIsLoading,
    onChangeOrder,
  } = props;

  const [sortValue, setSortValue] = React.useState('created_at-DESC');
  const [filterItem, setFilterItem] = React.useState(INITIAL_VALUE);
  const [filterList, setFilterList] = React.useState([]);
  const [isSortModal, setIsSortModal] = React.useState(null);

  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '등록일자',
      form: [
        {
          input: (
            <Flex gap="large" size="large">
              <Radio.Group
                size="large"
                onChange={(e) => {
                  setFilterItem((prev) => ({
                    ...prev,
                    start: dayjs()
                      .subtract(e.target.value, 'day')
                      .startOf('day'),
                    end: dayjs().endOf('day'),
                  }));
                }}
              >
                <Radio.Button value={1}>1일</Radio.Button>
                <Radio.Button value={7}>7일</Radio.Button>
                <Radio.Button value={30}>30일</Radio.Button>
                <Radio.Button value={90}>90일</Radio.Button>
              </Radio.Group>

              <Flex align="center" gap={4}>
                <DatePicker
                  size="large"
                  format={'YYYY-MM-DD'}
                  placeholder=""
                  style={{ ...styles.form.date, width: 150 }}
                  value={filterItem.start ? dayjs(filterItem.start) : ''}
                  onChange={(e) =>
                    setFilterItem((prev) => ({ ...prev, start: e }))
                  }
                  maxDate={filterItem.end}
                />
                <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
                <DatePicker
                  size="large"
                  format={'YYYY-MM-DD'}
                  placeholder=""
                  style={{ ...styles.form.date, width: 150 }}
                  value={filterItem.end ? dayjs(filterItem.end) : ''}
                  onChange={(e) =>
                    setFilterItem((prev) => ({ ...prev, end: e }))
                  }
                  minDate={filterItem.start}
                />
              </Flex>
            </Flex>
          ),
        },
      ],
    },
    {
      label: '검색어',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                value={filterItem.keyword}
                options={[
                  { label: '제목', value: 'event_title' },
                  { label: '혜택', value: 'event_benefit' },
                ]}
                style={{ ...styles.form.input.large }}
                onChange={(e) =>
                  setFilterItem((prev) => ({ ...prev, keyword: e }))
                }
              />
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
                value={filterItem.search}
                onChange={(e) =>
                  setFilterItem((prev) => ({ ...prev, search: e.target.value }))
                }
              />
            </>
          ),
        },
      ],
    },
    {
      label: '노출여부',
      form: [
        {
          input: (
            <Radio.Group
              value={filterItem.show}
              onChange={(e) =>
                setFilterItem((prev) => ({ ...prev, show: e.target.value }))
              }
            >
              <Radio value={''}>전체</Radio>
              <Radio value={'Y'}>노출</Radio>
              <Radio value={'N'}>숨김</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '메인노출',
      form: [
        {
          input: (
            <Radio.Group
              value={filterItem.main}
              onChange={(e) =>
                setFilterItem((prev) => ({ ...prev, main: e.target.value }))
              }
            >
              <Radio value={''}>전체</Radio>
              <Radio value={'Y'}>노출</Radio>
              <Radio value={'N'}>숨김</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
  ];

  const form = [
    {
      label: '이벤트 제목',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="새 이벤트의 제목을 입력해주세요"
              style={{ width: 400 }}
              value={modalData?.event?.event_title ?? ''}
              onChange={(e) => onChange('event_title', e.target.value, 'event')}
            />
          ),
          // count: true,
          // maxLength: 50,
        },
      ],
    },
    {
      label: '노출여부',
      required: true,
      form: [
        {
          input: (
            <Radio.Group
              value={modalData?.event?.is_show ?? 'N'}
              onChange={(e) => onChange('is_show', e.target.value, 'event')}
            >
              <Radio value={'Y'}>노출</Radio>
              <Radio value={'N'}>숨김</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '메인 여부',
      required: true,
      form: [
        {
          input: (
            <Radio.Group
              value={modalData?.event?.is_main ?? 'N'}
              onChange={(e) => onChange('is_main', e.target.value, 'event')}
            >
              <Radio value={'Y'}>메인</Radio>
              <Radio value={'N'}>일반</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '카테고리',
      required: true,
      form: [
        {
          input: (
            <Radio.Group
              value={modalData?.event?.type ?? 'ALL'}
              onChange={(e) => onChange('type', e.target.value, 'event')}
            >
              <Radio value={'STORE'}>매장</Radio>
              <Radio value={'SHOP'}>쇼핑몰</Radio>
              <Radio value={'ALL'}>모두</Radio>
            </Radio.Group>
          )
        }
      ]
    },
    {
      label: '이벤트 시작 날짜',
      required: true,
      form: [
        {
          input: (
            <DatePicker
              size="large"
              value={
                modalData?.event?.start_date &&
                dayjs(modalData?.event?.start_date)
              }
              placeholder="시작일을 선택해주세요"
              style={{ width: '100%' }}
              onChange={(_, dateString) =>
                onChange('start_date', dateString, 'event')
              }
            />
          ),
        },
      ],
    },
    {
      label: '이벤트 종료 날짜',
      required: true,
      form: [
        {
          input: (
            <DatePicker
              size="large"
              value={
                modalData?.event?.end_date && dayjs(modalData?.event?.end_date)
              }
              placeholder="종료일을 선택해주세요"
              style={{ width: '100%' }}
              onChange={(_, dateString) =>
                onChange('end_date', dateString, 'event')
              }
            />
          ),
        },
      ],
    },
    {
      label: '이벤트 썸네일',
      required: true,
      form: [
        {
          input: (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                padding: '20px 0px',
              }}
            >
              <UploadFile
                files={file}
                preview
                multiple
                max={1}
                onChange={onFileChange}
              />
            </div>
          ),
        },
      ],
    },

    {
      label: '이벤트 내용',
      form: [
        {
          input: (
            <Editor
              height={430}
              initialContent={modalData?.event?.event_content ?? ''}
              editorOnChange={(content) =>
                onChange('event_content', content, 'event')
              }
            />
          ),
          fullscreen: true,
        },
      ],
    },
    {
      label: '혜택 요약',
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="혜택 요약을 입력해주세요"
              style={{ width: 400 }}
              value={modalData?.event?.event_benefit ?? ''}
              onChange={(e) =>
                onChange('event_benefit', e.target.value, 'event')
              }
            />
          ),
          fullscreen: true,
        },
      ],
    },
  ];

  const col = [
    {
      title: '메인 노출 여부',
      key: 'is_main_html',
      dataIndex: 'is_main_html',
    },
    {
      title: '제목',
      key: 'event_title',
      width: 500,
      dataIndex: 'event_title',
    },
    {
      title: '시작일',
      key: 'start_date',
      render: (item) => moment(item).format('YYYY-MM-DD'),
      dataIndex: 'start_date',
    },
    {
      title: '종료일',
      key: 'end_date',
      render: (item) => moment(item).format('YYYY-MM-DD'),
      dataIndex: 'end_date',
    },
    {
      title: '등록일',
      key: 'created_at',
      render: (item) => moment(item).format('YYYY-MM-DD'),
      dataIndex: 'created_at',
    },
    {
      title: '수정일',
      key: 'updated_at',
      render: (item) => moment(item).format('YYYY-MM-DD'),
      dataIndex: 'updated_at',
    },
    {
      title: '노출여부',
      key: 'is_show',
      render: (item) => (
        <Tag color={item === 'Y' ? 'processing' : 'default'}>
          {item === 'Y' ? '노출' : '숨김'}
        </Tag>
      ),
      dataIndex: 'is_show',
    },
    {
      title: '노출순서',
      key: 'order',
      dataIndex: 'order',
      sorter: (a, b) => a?.order - b?.order,
    },
    {
      title:'카테고리',
      key: 'type',
      dataIndex: 'type',
      render: (item)=> {
        switch(item){
          case "ALL":
            return '모두 적용';
          case "STORE":
            return '매장';
          case "SHOP":
            return "쇼핑몰";
          default:
            return "모두 미적용";
        }
      }
      
    },
  ];
  /* ===== FUNCTION ===== */
  const handleSearch = (t) => {
    setIsLoading(true);
    const searchType = t.toLocaleUpperCase();

    let arr = [...tableData];
    switch (searchType) {
      case 'RESET':
        setFilterItem(INITIAL_VALUE);
        break;
      case 'SEARCH':
        const { start, end, keyword, search, show, main } = filterItem;

        if (search) {
          arr = arr.filter((event) => event[keyword]?.includes(search));
        }

        if (main) {
          arr = arr.filter((event) => event.is_main === main);
        }

        if (show) {
          arr = arr.filter((event) => event.is_show === show);
        }

        if (start || end) {
          const filterType = start && end ? 'BETWEEN' : start ? 'START' : 'END';

          switch (filterType) {
            case 'START':
              arr = arr.filter(
                (event) =>
                  dayjs(event.created_at).unix() >=
                  dayjs(start).startOf('day').unix()
              );
              break;
            case 'END':
              arr = arr.filter(
                (event) =>
                  dayjs(event.created_at).unix() <=
                  dayjs(end).endOf('day').unix()
              );
              break;
            case 'BETWEEN':
              arr = arr.filter(
                (event) =>
                  dayjs(event.created_at).unix() >=
                  dayjs(start).startOf('day').unix() &&
                  dayjs(event.created_at).unix() <=
                  dayjs(end).endOf('day').unix()
              );
              break;
            default:
              break;
          }
        }

        break;
      default:
        break;
    }

    setTimeout(() => {
      setIsLoading(false);
      setFilterList(arr);
    }, 1000);
  };

  /**
   * 아이템 순서 변경 (0-based index 기준)
   * @param {object} child - 순서를 변경할 대상 객체 (예: { banner_id, order, ... })
   * @param {number} newIndex - 목표 인덱스 (0부터 시작)
   */
  const orderChange = (child, newIndex) => {
    // sortItems는 객체 배열이어야 합니다.
    // 우선 기존 배열의 복사본을 생성합니다.
    const newArr = [...isSortModal];

    // 대상 객체의 현재 인덱스를 찾습니다.
    // banner_id나 다른 고유값을 기준으로 찾는 것을 권장합니다.
    const currentIndex = newArr.findIndex(
      (item) => item.event_id === child.event_id
    );
    if (currentIndex === -1) return; // 대상 객체를 찾지 못하면 종료
    if (currentIndex === newIndex) return; // 인덱스가 동일하면 변경할 필요 없음

    // 현재 인덱스에서 대상 아이템 제거
    const [movedItem] = newArr.splice(currentIndex, 1);
    // 목표 인덱스 위치에 대상 아이템 삽입
    newArr.splice(newIndex, 0, movedItem);

    // 배열 내의 모든 객체에 대해 order 값을 재할당 (1부터 시작하도록)
    const updatedList = newArr.map((item, index) => ({
      ...item,
      order: index + 1,
    }));

    // 최종 updatedList는 객체 배열 형태로 저장됩니다.
    setIsSortModal(updatedList);
  };

  /**
   * 테이블 데이터 생성
   * @returns {Array}
   */
  const tableData = React.useMemo(() => {
    const newData = data?.map((item) => ({
      ...item,
      key: item?.event_id,
      event_id: item?.event_id,
      is_main_html:
        item?.is_main === 'Y' ? (
          <span
            style={{
              border: '1px solid #58cf04',
              color: '#58cf04',
              borderRadius: 2,
              padding: '1px 11px',
            }}
          >
            메인
          </span>
        ) : (
          <span
            style={{
              border: '1px solid #37383C',
              color: '#37383C',
              borderRadius: 2,
              padding: '1px 11px',
            }}
          >
            일반
          </span>
        ),
      is_show_html: <Switch checked={item?.is_show === 'Y'} />,
    }));

    const split = sortValue.split('-');
    console.log('split ===>', split);
    const sortData = newData?.sort((a, b) => {
      switch (split[1]) {
        case 'DESC':
          return b[split[0]] - a[split[0]];
        case 'ASC':
          return a[split[0]] - b[split[0]];
        default:
          return 0;
      }
    });

    return sortData;
  }, [data, sortValue]);

  React.useEffect(() => {
    setFilterList(tableData);
  }, [tableData]);

  /* ===== RENDER ===== */
  return (
    <>
      <Spin spinning={isLoading}>
        <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
          <Row>
            <Col x={24}>
              <Title style={{ ...styles.title }}>이벤트 관리</Title>
              {/* 검색필터 */}
              <Content
                maxWidth={'100%'}
                padding={0}
                backgroundColor={'none'}
                style={{ marginBottom: 40 }}
              >
                <ExpandableContainer borderRadius={4} padding={20}>
                  {formItem.map((_item, _index) => (
                    <div
                      key={`form_${_index}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '10px 0px',
                      }}
                    >
                      <div
                        style={{ minWidth: 120, fontSize: 13, fontWeight: 400 }}
                      >
                        <label>{_item.label}</label>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {_item.form.map((_subitem, _subkey) => (
                          <React.Fragment key={`input_${_subkey}`}>
                            {_subitem.input}
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  ))}
                </ExpandableContainer>

                {/* 검색/초기화 버튼 */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    marginTop: 48,
                  }}
                >
                  <Button
                    size="large"
                    type="primary"
                    style={{
                      ...styles.button,
                      background: 'var(--primary-color)',
                    }}
                    onClick={() => handleSearch('search')}
                  >
                    검색
                  </Button>
                  <Button
                    size="large"
                    style={{ ...styles.button }}
                    onClick={() => handleSearch('reset')}
                  >
                    초기화
                  </Button>
                </div>
              </Content>

              {/* 검색결과 */}
              <Content maxWidth={'100%'} borderRadius={4} padding={20}>
                <Flex justify="space-between" align="center">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 20,
                    }}
                  >
                    <h4
                      style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}
                    >
                      총 <span>{filterList?.length}</span>개
                    </h4>
                    <Button
                      size="large"
                      style={{ marginRight: 8 }}
                      onClick={() =>
                        onOpen(isOpened, 'event', {
                          is_show: 'Y',
                          is_main: 'Y',
                        })
                      }
                    >
                      새 이벤트
                    </Button>
                    <Button
                      size="large"
                      style={{ marginRight: 8 }}
                      onClick={() => setIsSortModal(data)}
                    >
                      순서변경
                    </Button>
                    <Button
                      style={{ marginRight: 8 }}
                      size="large"
                      onClick={() =>
                        downloadXlsx({
                          columns: col,
                          rows: filterList?.map((_item) => ({
                            ..._item,
                            is_main_html:
                              _item?.is_main === 'Y' ? '메인' : '일반',
                          })),
                          fileName: '이벤트',
                        })
                      }
                    >
                      엑셀로 다운로드
                    </Button>
                    <Button
                      size="large"
                      style={{ marginRight: 8 }}
                      icon={<DeleteOutlined />}
                      danger
                      onClick={() => onDelete()}
                    >
                      선택 삭제
                    </Button>
                  </div>

                  <Select
                    options={SORT_ITEMS}
                    value={sortValue}
                    onChange={(e) => setSortValue(e)}
                    style={{ width: 200 }}
                  />
                </Flex>
                <Table
                  data={filterList}
                  // dataSource={filterList}
                  isChecked
                  onRow={(item) => {
                    onOpen(isOpened, 'event', { ...item });
                  }}
                  columns={col}
                  checkedAll={isCheckedAll}
                  checkedList={checkedList}
                  onChecked={onChecked}
                  onCheckedAll={onCheckedAll}
                />
              </Content>
            </Col>
          </Row>
        </Content>
      </Spin>

      {/* 모달 */}
      <ModalLayout
        type="modal"
        centered
        title={'이벤트 등록'}
        open={isOpened && modalType === 'event'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={798}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button
              type="primary"
              onClick={() =>
                onSubmit(
                  'event',
                  modalData?.event?.event_id ? 'UPDATE' : 'CREATE'
                )
              }
            >
              저장
            </Button>
          </Content>
        }
      >
        <Content
          maxWidth={'100%'}
          padding={'20px 0'}
          style={{
            borderTop: '1px solid #F4F4F5',
            borderBottom: '1px solid #F4F4F5',
          }}
        >
          <Row>
            <Col x={24}>
              {modalType === 'DETAIL' ? (
                <div>
                  <HtmlContent content={modalData.event_content} />
                </div>
              ) : (
                <InputFormTable form={form} labelWidth={148} />
              )}
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      {/* SECTION: 순서변경 모달 */}
      <ModalLayout
        type={'modal'}
        open={!!isSortModal}
        onCancel={() => setIsSortModal(null)}
        centered
        closable
        width={500}
        footer={
          <Content maxWidth={'100%'} padding={0}>
            <Row>
              <Col x={24}>
                <Flex justify="flex-end">
                  <Button
                    type="primary"
                    style={{
                      ...styles.button,
                      background: 'var(--primary-color)',
                    }}
                    onClick={() =>
                      onChangeOrder(isSortModal, () => setIsSortModal(null))
                    }
                  >
                    저장
                  </Button>
                </Flex>
              </Col>
            </Row>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'20px 0'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <Flex vertical gap={24} style={{ padding: '12px 0px' }}>
                  {isSortModal?.map((_item, _index) => (
                    <Flex
                      key={`banner-${_item.banner_id}`}
                      justify="space-between"
                      align="center"
                    >
                      <Flex align="center" gap={12}>
                        <div
                          style={{
                            width: 80,
                            height: 80,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1px solid #BDBDBD',
                          }}
                        >
                          <Image
                            src={`${STORE_URL}/${_item?.thumbnail_url}`}
                            width={80}
                            height={'100%'}
                            style={{ objectFit: 'cover' }}
                          />
                        </div>
                        <Text weight={700}>{_item?.event_title}</Text>
                      </Flex>

                      <Select
                        value={_index}
                        options={new Array(isSortModal?.length)
                          .fill(null)
                          .map((_, index) => ({
                            label: `${index + 1}번`,
                            value: index,
                          }))}
                        onChange={(e) => orderChange(_item, Number(e))}
                      />
                    </Flex>
                  ))}
                </Flex>
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default EventListPresenter;
